angular.module('ui2.0',['ui2.0Controllers','ui2.0Service','ui2.0Directives','letterAvatar','ui2.0constants','ui2.0filters','angular-click-outside','ui.bootstrap.datetimepicker']);
angular.module('ui2.0Controllers',[]); /* Controller Module */
angular.module('ui2.0Directives',[]);  /* Directive Module */
angular.module('ui2.0Service',[]);     /* Services Module */
angular.module('ui2.0constants',[]);   /* Constants Module */
angular.module('ui2.0filters',[]);   /* Constants Module */
